<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>
<div *ngIf="oneDayUserCount">
	{{ 'adminstat.common.userCount' | translate }}: <span class="badge badge-secondary">{{ oneDayUserCount }}</span>
</div>

<chart [data]="oneDayChart.data" [options]="oneDayChart.options" [sextant]="'oneDay'" [url]="filter.currentUrl"></chart>
<br>

<div *ngIf="oneDayUserCount">
	<ngb-accordion #acc="ngbAccordion" *ngIf="oneDayChart.data">
		<ngb-panel title="{{ 'adminstat.common.description' | translate }}">
			<ng-template ngbPanelContent>
				График учитывает пользователей, что:
				<ul>
					<li>создали сайт в день регистрации</li>
					<li>имеют только один сайт (про это условие может пояснить Ира)</li>
					<li>сайт последний раз редактировался более трех дней назад</li>
					<li>каждый столбец - кол-во пользователей, группированых по разнице между датой создания сайта и датой реги (в часах)</li>
				</ul>
			</ng-template>
		</ngb-panel>
	</ngb-accordion>
</div>

<div *ngIf="(widgetData | keys).length > 0">
	<br><hr><br>
	{{ 'adminstat.common.siteCount' | translate }}: <span class="badge badge-secondary">{{ widgetData.totalCount }}</span>,
	{{ 'adminstat.common.In query count' | translate }}: <span class="badge badge-secondary">{{ widgetData.queryCount }}</span>,
	{{ 'adminstat.common.level of quality' | translate }}: <span class="badge badge-secondary">{{(100 * widgetData.afterLevel / widgetData.beforeLevel).toFixed(0) }}</span> %,
	{{ 'adminstat.common.percent good traffic' | translate }}: <span class="badge badge-secondary">{{(100 * (widgetData.afterLevel / (widgetData.afterLevel + widgetData.beforeLevel))).toFixed(0) }}</span> %

	<div class="form-group">
		<br><label>{{ 'adminstat.users.graph.add widgets count' | translate }}</label><br>
		{{ 'adminstat.common.from' | translate }}   <input type="text" class="form-control" [(ngModel)]="widgetData.startCount" [ngModelOptions]="{standalone: true}">
		{{ 'adminstat.common.to' | translate }}     <input type="text" class="form-control" [(ngModel)]="widgetData.endCount" [ngModelOptions]="{standalone: true}">
		{{ 'adminstat.common.border' | translate }} <input type="text" class="form-control" [(ngModel)]="widgetData.border" [ngModelOptions]="{standalone: true}">
	</div>

	<div class="form-group">
		<button type="button" class="btn btn-success" (click)="customApplyFilters('widget')" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
		<button type="button" class="btn btn-link" style="color:red;" (click)="customResetFilters('widget')">{{ 'adminstat.common.Reset filters' | translate }}</button>
	</div>
</div>
<chart [data]="widgetChart.data" [options]="widgetChart.options" [sextant]="'widget'" [url]="filter.currentUrl"></chart>
<br>

<div *ngIf="(actionData | keys).length > 0">
	<br><hr><br>
	{{ 'adminstat.common.userCount' | translate }}: <span class="badge badge-secondary">{{ actionData.totalCount }}</span>,
	{{ 'adminstat.common.In query count' | translate }}: <span class="badge badge-secondary">{{ actionData.queryCount }}</span>,
	{{ 'adminstat.common.level of quality' | translate }}: <span class="badge badge-secondary">{{ (100 * actionData.afterLevel / actionData.beforeLevel).toFixed(0) }}</span> %,
	{{ 'adminstat.common.percent good traffic' | translate }}: <span class="badge badge-secondary">{{ (100 * (actionData.afterLevel / (actionData.afterLevel + actionData.beforeLevel))).toFixed(0) }}</span> %

	<div class="form-group">
		<br><label>{{ 'adminstat.users.graph.action count' | translate }}</label><br>
		{{ 'adminstat.common.from' | translate }}   <input type="text" class="form-control" [(ngModel)]="actionData.startCount" [ngModelOptions]="{standalone: true}">
		{{ 'adminstat.common.to' | translate }}     <input type="text" class="form-control" [(ngModel)]="actionData.endCount" [ngModelOptions]="{standalone: true}">
		{{ 'adminstat.common.border' | translate }} <input type="text" class="form-control" [(ngModel)]="actionData.border" [ngModelOptions]="{standalone: true}">
	</div>

	<div class="form-group">
		<button type="button" class="btn btn-success" (click)="customApplyFilters('action')" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
		<button type="button" class="btn btn-link" style="color:red;" (click)="customResetFilters('action')">{{ 'adminstat.common.Reset filters' | translate }}</button>
	</div>
</div>
<chart [data]="actionChart.data" [options]="actionChart.options" [sextant]="'activity'" [url]="filter.currentUrl"></chart>
<br>
